import Vue from 'vue';
export const EventBus = new Vue();
export const showRastreamento = (id) =>  EventBus.$emit('rastreamento', id);
